export type OnboardingStep = {
  index: number
  title: string,
  secondaryTitle?: string,
  description: string,
  image?: string
  buttonLabel?: string
}

export enum UserGuide {
  Quests = 'quests',
  Improve = 'improve',
  LoyaltyLeaderboard = 'loyalty_leaderboard',
}